import styles from "./NavBar.module.css";

import React, { useContext, useEffect, useState, useCallback, useMemo } from "react";
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import '../../resources/css/common.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import dashboardIcon from '../../../src/resources/images/menu/menu_ico_1.svg';
import userIcon from '../../../src/resources/images/menu/menu_ico_2.svg';
import serviceIcon from '../../../src/resources/images/menu/menu_ico_3.svg';
import authIcon from '../../../src/resources/images/menu/menu_ico_5.svg';
import pageAuthIcon from '../../../src/resources/images/menu/menu_ico_6.svg';
import groupIcon from '../../../src/resources/images/menu/menu_ico_7.svg';
import auditIcon from '../../../src/resources/images/menu/menu_ico_9.svg';
import { useTenantList } from "../../utils/service/tenantList";
import FooterInfo from "./component/FooterInfo";

import { useModal, useDialog, InnocodeList, InnocodeProfileButton, InnocodeButton } from '@intsoft/innocode-core';
import { PasswordChangeModal } from '../../resources/modal/PasswordChangeModal';
import { usePasswordChangeModal } from "./component/usePasswordChangeModal";



export const NavType = {
    //유저관리
    ACCOUNT: 'account',
    SECURITY: 'security',

    //테넌트 관리
    TENANTS_USER: 'tenants_user',
    TENANTUSER_USER: 'tenantuser_user',
    SERVICE: 'service',

    //결제 및 구독
    PAYMENT: 'payment',
    PAYMENT_HISTORY: 'payment_history',
    PAY_PASSWORD: 'payment_password',
    SUBSCRIPTION: 'subscription',


    //IAM 관리자
    DASHBOARD_ADMIN: 'dashboard_admin',
    TENANTS_ADMIN: 'tenants_admin',
    USERMGMT_ADMIN: 'usermgmt_admin',
    AUDIT_ADMIN: 'audit_admin',
    SSO_SERVICE_GROUP_ADMIN: 'sso_service_group_admin',
    SSO_FEDERATION_ADMIN: 'sso_federation_admin',

    //서비스 관리
    DASHBOARD_SERVICE: 'dashboard_service',
    AUTH: 'auth',
    PAGE: 'page',
    PAGE_AUTH: 'pageauth',
    GROUP: 'group',
    SERVICE_USER: 'serviceuser',
    SERVICE_USER_APPROVAL: 'serviceuser_approval',
}

export const pathToNavType = {
    '/account/manage': NavType.ACCOUNT,
    '/security': NavType.SECURITY,
    '/tenants': NavType.TENANTS_USER,
    '/tenantuser': NavType.TENANTUSER_USER,
    '/service': NavType.SERVICE,

    '/payment': NavType.PAYMENT,
    '/payment_history': NavType.PAYMENT_HISTORY,
    '/subscription': NavType.SUBSCRIPTION,


    '/dashboard': NavType.DASHBOARD_ADMIN,
    '/tenantsMagement': NavType.TENANTS_ADMIN,
    '/usermgmt': NavType.USERMGMT_ADMIN,
    '/audit': NavType.AUDIT_ADMIN,
    '/sso-service-groups': NavType.SSO_SERVICE_GROUP_ADMIN,
    '/sso-federations': NavType.SSO_FEDERATION_ADMIN,

    '/service/dashboard': NavType.DASHBOARD_SERVICE,
    '/service/page': NavType.PAGE,
    '/service/auth': NavType.AUTH,
    '/service/pageauth': NavType.PAGE_AUTH,
    '/service/group': NavType.GROUP,
    '/service/serviceuser': NavType.SERVICE_USER,
    '/service/serviceuser-approval': NavType.SERVICE_USER_APPROVAL,


};

// 1. 메뉴 배열로 관리
const mainMenuList = [


    //계정관리 일반 유저
    {
        key: "account",
        path: "/account/manage",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z" clip-rule="evenodd" />
        </svg>
        ,
        label: "사용자 정보",
        roles: ["USER", "SYS_ADMIN"] // 모든 권한 허용
    },
    {
        key: "tenants_group",
        icon: <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M4 4a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2v14a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2V5a1 1 0 0 1-1-1Zm5 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H9Zm5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1Zm-5 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H9Zm5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1Zm-3 4a2 2 0 0 0-2 2v3h2v-3h2v3h2v-3a2 2 0 0 0-2-2h-2Z" clip-rule="evenodd" />
        </svg>,
        label: "테넌트",
        roles: ["USER", "SYS_ADMIN"],
        children: [
            {
                key: NavType.TENANTS_USER,
                path: "/tenants",
                icon: null,
                label: "테넌트 관리",
                roles: ["USER", "SYS_ADMIN"]
            },
            {
                key: NavType.TENANTUSER_USER,
                path: "/tenantuser",
                icon: null, // 아이콘 변경 필요 시
                label: "테넌트유저 관리",
                roles: ["USER", "SYS_ADMIN"]
            },
            { //테넌트 서비스 관리
                key: NavType.SERVICE,
                path: "/service",
                icon: null,
                label: "서비스관리",
                roles: ["SYS_ADMIN", "USER"]
            },
        ]
    },

    {  //sso 관리
        key: "sso_group",
        icon: <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fillRule="evenodd" d="M12 3a3 3 0 0 0-3 3v1.07A7.002 7.002 0 0 0 5 13.5V18a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-4.5A7.002 7.002 0 0 0 15 7.07V6a3 3 0 0 0-3-3Zm1 4.29a7.027 7.027 0 0 0-2 0V6a1 1 0 1 1 2 0v1.29ZM8 11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H8Z" clipRule="evenodd" />
        </svg>,
        label: "SSO 서비스 관리",
        roles: ["SYS_ADMIN"],
        children: [
            {
                key: NavType.SSO_SERVICE_GROUP_ADMIN,
                path: "/sso-service-groups",
                icon: null,
                label: "서비스 그룹 관리",
                roles: ["SYS_ADMIN"]
            },
            {
                key: NavType.SSO_FEDERATION_ADMIN,
                path: "/sso-federations",
                icon: null,
                label: "테넌트 연합 관리",
                roles: ["SYS_ADMIN"]
            },
            {
                key: "SSO_OPERATION_POLICY",
                path: "/sso-operations",
                icon: null,
                label: "운영 설정",
                roles: ["SYS_ADMIN"]
            },
        ]
    },

    {    //결제 및 구독
        key: "payment_group",
        icon: <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4Zm0 6h16v6H4v-6Z" clip-rule="evenodd" />
            <path fill-rule="evenodd" d="M5 14a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Zm5 0a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1Z" clip-rule="evenodd" />
        </svg>,

        label: "결제 및 구독",
        roles: ["USER", "SYS_ADMIN"],
        children: [
            {
                key: NavType.PAYMENT,
                path: "/payment",
                icon: null,
                label: "결제 관리",
                roles: ["USER", "SYS_ADMIN"]
            },
            {
                key: NavType.PAY_PASSWORD,
                path: "/pay_password",
                icon: null,
                label: "결제비밀번호 변경",
                roles: ["USER", "SYS_ADMIN"],

            },
            {
                key: NavType.PAYMENT_HISTORY,
                path: "/payment_history",
                icon: null,
                label: "결제 내역",
                roles: ["USER", "SYS_ADMIN"],
                childrenUrl: [
                    "/detail",
                ]
            },
            {
                key: NavType.SUBSCRIPTION,
                path: "/subscription",
                icon: null,
                label: "구독 관리",
                roles: ["SYS_ADMIN", "USER"],
                childrenUrl: [
                    "/detail",
                ]
            },
        ]
    },

    // 시스템 관리자 네비
    {
        key: "iam_admin_group",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4h-4Z" clip-rule="evenodd" />
        </svg>
        ,
        label: "IAM 관리자",
        roles: ["SYS_ADMIN"],
        children: [
            // {
            //     key: NavType.DASHBOARD_ADMIN,
            //     path: "/dashboard",
            //     icon: null,
            //     label: "대시보드",
            //     roles: ["SYS_ADMIN"] // 모든 권한 허용
            // },
            // {
            //     key: NavType.USERMGMT_ADMIN,
            //     path: "/usermgmt",
            //     icon: null,
            //     label: "통합사용자관리",
            //     roles: ["SYS_ADMIN"] // SYS_ADMIN만
            // },
            {
                key: NavType.TENANTS_ADMIN,
                path: "/tenantsMagement",
                icon: null,
                label: "통합테넌트관리",
                roles: ["SYS_ADMIN"]
            },
            // {
            //     key: NavType.SERVICE,
            //     path: "/serviceMagement",
            //     icon: pageAuthIcon,
            //     label: "통합서비스관리",
            //     roles: ["SYS_ADMIN"]
            // },
            // {
            //     key: NavType.AUDIT_ADMIN,
            //     path: "/audit",
            //     icon: null,
            //     label: "로그관리",
            //     roles: ["SYS_ADMIN"]
            // },
        ]
    },

    {
        key: "security",
        path: "/security",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M17 10v1.126c.367.095.714.24 1.032.428l.796-.797 1.415 1.415-.797.796c.188.318.333.665.428 1.032H21v2h-1.126c-.095.367-.24.714-.428 1.032l.797.796-1.415 1.415-.796-.797a3.979 3.979 0 0 1-1.032.428V20h-2v-1.126a3.977 3.977 0 0 1-1.032-.428l-.796.797-1.415-1.415.797-.796A3.975 3.975 0 0 1 12.126 16H11v-2h1.126c.095-.367.24-.714.428-1.032l-.797-.796 1.415-1.415.796.797A3.977 3.977 0 0 1 15 11.126V10h2Zm.406 3.578.016.016c.354.358.574.85.578 1.392v.028a2 2 0 0 1-3.409 1.406l-.01-.012a2 2 0 0 1 2.826-2.83ZM5 8a4 4 0 1 1 7.938.703 7.029 7.029 0 0 0-3.235 3.235A4 4 0 0 1 5 8Zm4.29 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h6.101A6.979 6.979 0 0 1 9 15c0-.695.101-1.366.29-2Z" clip-rule="evenodd" />
        </svg>,

        label: "보안",
        roles: ["USER", "SYS_ADMIN"] // 모든 권한 허용
    },
];

// "서비스 관리 모드"에서 1뎁스로 사용될 메뉴 목록
const serviceManagementMenuList = [
    { // 서비스 대시보드
        key: NavType.DASHBOARD_SERVICE,
        path: "/service/dashboard",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M5 3a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm14 18a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4ZM5 11a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H5Zm14 2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4Z" />
        </svg>,

        label: "대시보드",
        roles: ["USER"], // 모든 권한 허용
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.PAGE,
        path: "/service/page",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-7Z" clip-rule="evenodd" />
        </svg>,

        label: "페이지관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.AUTH,
        path: "/service/auth",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M17 10v1.126c.367.095.714.24 1.032.428l.796-.797 1.415 1.415-.797.796c.188.318.333.665.428 1.032H21v2h-1.126c-.095.367-.24.714-.428 1.032l.797.796-1.415 1.415-.796-.797a3.979 3.979 0 0 1-1.032.428V20h-2v-1.126a3.977 3.977 0 0 1-1.032-.428l-.796.797-1.415-1.415.797-.796A3.975 3.975 0 0 1 12.126 16H11v-2h1.126c.095-.367.24-.714.428-1.032l-.797-.796 1.415-1.415.796.797A3.977 3.977 0 0 1 15 11.126V10h2Zm.406 3.578.016.016c.354.358.574.85.578 1.392v.028a2 2 0 0 1-3.409 1.406l-.01-.012a2 2 0 0 1 2.826-2.83ZM5 8a4 4 0 1 1 7.938.703 7.029 7.029 0 0 0-3.235 3.235A4 4 0 0 1 5 8Zm4.29 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h6.101A6.979 6.979 0 0 1 9 15c0-.695.101-1.366.29-2Z" clip-rule="evenodd" />
        </svg>
        ,
        label: "권한관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.PAGE_AUTH,
        path: "/service/pageauth",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v5.703l-4.311-1.58a2 2 0 0 0-1.377 0l-5 1.832A2 2 0 0 0 8 11.861c.03 2.134.582 4.228 1.607 6.106.848 1.555 2 2.924 3.382 4.033H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z" clip-rule="evenodd" />
            <path fill-rule="evenodd" d="M15.345 9.061a1 1 0 0 0-.689 0l-5 1.833a1 1 0 0 0-.656.953c.028 1.97.538 3.905 1.485 5.641a12.425 12.425 0 0 0 3.956 4.34 1 1 0 0 0 1.12 0 12.426 12.426 0 0 0 3.954-4.34A12.14 12.14 0 0 0 21 11.848a1 1 0 0 0-.656-.954l-5-1.833ZM15 19.765a10.401 10.401 0 0 0 2.76-3.235 10.15 10.15 0 0 0 1.206-4.011L15 11.065v8.7Z" clip-rule="evenodd" />
        </svg>
        ,
        label: "페이지권환관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.GROUP,
        path: "/service/group",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm-1.5 8a4 4 0 0 0-4 4 2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-3Zm6.82-3.096a5.51 5.51 0 0 0-2.797-6.293 3.5 3.5 0 1 1 2.796 6.292ZM19.5 18h.5a2 2 0 0 0 2-2 4 4 0 0 0-4-4h-1.1a5.503 5.503 0 0 1-.471.762A5.998 5.998 0 0 1 19.5 18ZM4 7.5a3.5 3.5 0 0 1 5.477-2.889 5.5 5.5 0 0 0-2.796 6.293A3.501 3.501 0 0 1 4 7.5ZM7.1 12H6a4 4 0 0 0-4 4 2 2 0 0 0 2 2h.5a5.998 5.998 0 0 1 3.071-5.238A5.505 5.505 0 0 1 7.1 12Z" clip-rule="evenodd" />
        </svg>
        ,
        label: "그룹관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.SERVICE_USER,
        path: "/service/serviceuser",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fill-rule="evenodd" d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm7.25-2.095c.478-.86.75-1.85.75-2.905a5.973 5.973 0 0 0-.75-2.906 4 4 0 1 1 0 5.811ZM15.466 20c.34-.588.535-1.271.535-2v-1a5.978 5.978 0 0 0-1.528-4H18a4 4 0 0 1 4 4v1a2 2 0 0 1-2 2h-4.535Z" clip-rule="evenodd" />
        </svg>,

        label: "서비스사용자관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"] // OWNER 또는 MANAGER만 접근 가능
    },
    {
        key: NavType.SERVICE_USER_APPROVAL,
        path: "/service/serviceuser-approval",
        icon: <svg className={styles.leftCont__menu__icon} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path fillRule="evenodd" d="M8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4H6Zm12.293-3.707a1 1 0 0 1 1.414 1.414l-4.25 4.25a1 1 0 0 1-1.414 0l-1.75-1.75a1 1 0 1 1 1.414-1.414l1.043 1.043 3.543-3.543Z" clipRule="evenodd" />
        </svg>,
        label: "가입 승인 관리",
        roles: ["SYS_ADMIN", "USER"],
        tenantType: ["owner", "manager"]
    },
];


/**
 * Navigation Bar Container
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */
function NavBar({ type, viewMode, isMobileMenuOpen, setIsMobileMenuOpen, user, tokenExpiredTime, sessionLogout }) {
    // console.log("NavBar component rendered");

    const { role } = useContext(AuthContext);
    const movePage = useNavigate();
    const { tenantList, isLoading: tenantListLoading } = useTenantList();
    const location = useLocation();

    const { handleOpenModal, isLoading } = usePasswordChangeModal();

    // 1뎁스 메뉴의 열림/닫힘 상태를 관리하는 객체
    const [openMenuKey, setOpenMenuKey] = useState(null);
    const [isExpanded, setIsExpanded] = useState(true);

    useEffect(() => {
    }, [openMenuKey]);

    const hasMenuAccess = useCallback((menu) => {
        if (menu?.path === "/sso-operations") {
            return false;
        }

        const hasRoleAccess = !menu.roles || menu.roles.length === 0 || (role && menu.roles.some(r => role.includes(r)));
        if (!hasRoleAccess) return false;

        if (menu.tenantType && menu.tenantType.length > 0) {
            if (tenantListLoading) return false;
            const hasTenantTypeAccess = tenantList.some((tenant) => {
                const currentTenantType = tenant?.currentUserPermission?.tenantType?.toLowerCase();
                const fallbackTenantType = tenant?.tenantType?.toLowerCase();
                return menu.tenantType.includes(currentTenantType || fallbackTenantType);
            });
            if (!hasTenantTypeAccess) return false;
        }

        if (role && role.includes("SYS_ADMIN")) {
            return true;
        }
        return true;
    }, [role, tenantList, tenantListLoading]);

    const menusToRender = useMemo(() => {
        return viewMode === 'service_only'
            ? serviceManagementMenuList // 서비스 관리 모드일 경우, 서비스 메뉴 목록을 직접 사용
            : mainMenuList;             // 그 외의 경우, 메인 메뉴 목록을 사용
    }, [viewMode]);

    // 현재 페이지(type)에 따라 부모 메뉴를 열린 상태로 초기화
    // useEffect(() => {
    //     // menusToRender에서 현재 type의 부모를 찾습니다.
    //     const currentParent = menusToRender.find(parent =>
    //         parent.children?.some(child => child.key === type)
    //     );

    //     if (currentParent) {
    //         setOpenMenuKey(currentParent.key);
    //     } else {
    //         setOpenMenuKey(null);
    //     }
    // }, [type, menusToRender]); // menusToRender가 변경될 때도 이 효과를 재실행



    // 1뎁스 메뉴 클릭 핸들러
    const handleParentMenuClick = useCallback((parentMenuKey) => {
        // 1. 메뉴가 이미 확장된 상태일 때 (기존 로직)
        if (isExpanded) {
            // 클릭된 메뉴가 이미 열려있으면 닫고 (null), 그렇지 않으면 연다 (parentMenuKey).
            setOpenMenuKey(prevOpenMenuKey =>
                prevOpenMenuKey === parentMenuKey ? null : parentMenuKey
            );
        }
        // 2. 메뉴가 축소된 상태일 때 (새로운 로직)
        else {
            // 먼저 메뉴를 확장시키고,
            setIsExpanded(true);
            // 그 다음, 클릭된 메뉴를 항상 열린 상태로 설정합니다.
            setOpenMenuKey(parentMenuKey);
        }
    }, [isExpanded]);

    // 현재 경로가 메뉴 항목과 일치하는지 확인하는 함수
    const isMenuActive = useCallback((menuItem) => {
        const currentPath = location.pathname;

        // 정확히 일치하는 경우
        if (currentPath === menuItem.path) {
            return true;
        }

        // childrenUrl이 있는 경우, 자식 URL도 확인
        if (menuItem.childrenUrl && Array.isArray(menuItem.childrenUrl)) {
            return menuItem.childrenUrl.some(childUrl =>
                currentPath.startsWith(menuItem.path + childUrl)
            );
        }

        return false;
    }, [location.pathname]);

    // 페이지 로드 시 현재 경로에 맞는 메뉴 열기
    useEffect(() => {
        const activeParent = menusToRender.find(parentMenu => {
            if (Array.isArray(parentMenu.children)) {
                return parentMenu.children.some(child => isMenuActive(child));
            }
            return false;
        });

        if (activeParent) {
            setOpenMenuKey(activeParent.key);
        }
    }, [location.pathname, viewMode, isMenuActive]);

    // 1뎁스 메뉴 렌더링 함수
    const renderParentMenu = (menu) => {
        const hasChildren = Array.isArray(menu.children) && menu.children.length > 0;
        const isCurrentParent = hasChildren ? menu.children.some(child => isMenuActive(child)) : false;
        const isActive = isCurrentParent || (!hasChildren && isMenuActive(menu));

        const isOpen = openMenuKey === menu.key;


        const canAccessAnyChild = hasChildren ? menu.children.some(child => hasMenuAccess(child)) : false;

        if (!hasMenuAccess(menu) || (hasChildren && !canAccessAnyChild)) {
            return null;
        }

        return (
            <li key={menu.key} className={`${styles.parentMenuItem} ${isActive ? styles.activeParent : ''}`}>
                {!hasChildren ? (
                    <Link
                        to={`${menu.path}${viewMode ? `?view=${viewMode}` : ''}`}
                        onClick={() => setIsMobileMenuOpen(false)}>
                        <InnocodeList
                            leadingIcon={true}
                            trailingIcon={true}
                            borderRadius="12px"
                            backgroundColor={isActive ? "var(--assistive-strong, #b9b9c63d)" : "transparent"}
                        >
                            <span {...{ "slot": "leading-icon" }} className={styles.leftCont__menu__icon}>
                                {menu.icon}
                            </span>
                            <p className={styles.leftCont__menu__link}><span>{menu.label}</span></p>
                            {hasChildren && isExpanded && (
                                <span className={`${styles.arrowIcon} `}>
                                    {isOpen ? (
                                        <svg {...{ "slot": "trailing-icon" }} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 15 7-7 7 7" />
                                        </svg>
                                    ) : (
                                        <svg {...{ "slot": "trailing-icon" }} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7" />
                                        </svg>
                                    )}
                                </span>
                            )}
                        </InnocodeList>
                    </Link>
                ) :
                    (
                        <InnocodeList
                            leadingIcon={true}
                            trailingIcon={true}
                            onClick={() => handleParentMenuClick(menu.key)}
                            borderRadius="12px"
                            backgroundColor={(isMenuActive(menu) && isActive) ? "var(--assistive-strong, #b9b9c63d)" : "transparent"}
                        >
                            <span {...{ "slot": "leading-icon" }} className={styles.leftCont__menu__icon}>
                                {menu.icon}
                            </span>
                            <p className={styles.leftCont__menu__link}><span>{menu.label}</span></p>
                            {hasChildren && isExpanded && (
                                <span {...{ "slot": "trailing-icon" }} className={`${styles.arrowIcon} `}>
                                    {isOpen ? (
                                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m5 15 7-7 7 7" />
                                        </svg>
                                    ) : (
                                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7" />
                                        </svg>
                                    )}
                                </span>
                            )}
                        </InnocodeList>
                    )
                }
                {hasChildren && isOpen && (
                    <ul className={styles.leftCont__submenu}>
                        {menu.children.map(childMenu =>
                            hasMenuAccess(childMenu) && (
                                childMenu.path === '/pay_password' ? (
                                    // <li key={childMenu.key} className={`${styles.leftCont__menu__li}`}
                                    //     onClick={() => {
                                    //         if (isLoading) return;
                                    //         handleOpenModal({});
                                    //     }}
                                    // >
                                    //     <p className={styles.leftCont__menu__link}><span>{childMenu.label}</span></p>
                                    // </li>
                                    <InnocodeList
                                        size={"sm"}
                                        key={childMenu.key}
                                        borderRadius="12px"
                                        onClick={() => {
                                            if (isLoading) return;
                                            handleOpenModal({});
                                        }}
                                    >
                                        <p className={styles.leftCont__menu__link}><span>{childMenu.label}</span></p>
                                    </InnocodeList>
                                ) : (
                                    <Link
                                        to={`${childMenu.path}${viewMode ? `?view=${viewMode}` : ''}`}
                                        className={styles.leftCont__menu__link__txt}
                                        key={childMenu.key}
                                        onClick={() => setIsMobileMenuOpen(false)}>
                                        {/* <li className={`${styles.leftCont__menu__li} ${type === childMenu.key ? styles.on : ''}`}> */}
                                        {/* <li className={`${styles.leftCont__menu__li} ${isMenuActive(childMenu) ? styles.on : ''}`}>
                                            <p className={styles.leftCont__menu__link}><span>{childMenu.label}</span></p>
                                        </li> */}
                                        <InnocodeList
                                            size={"sm"}
                                            borderRadius="12px"
                                            backgroundColor={isMenuActive(childMenu) ? "var(--assistive-strong, #b9b9c63d)" : "transparent"}
                                        >
                                            <p className={styles.leftCont__menu__link}><span>{childMenu.label}</span></p>
                                        </InnocodeList>
                                    </Link>
                                )
                            )
                        )}
                    </ul>
                )}
            </li>
        );

    };

    // 모바일 메뉴가 열렸을 때 body 스크롤 방지
    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        // 컴포넌트 언마운트 시 스크롤 복원
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMobileMenuOpen]);

    // 모바일 하단에 표시할 핵심 메뉴 (최대 4~5개)
    const mainMobileMenus = mainMenuList.filter(menu =>
        ["account", "tenants", "security"].includes(menu.key) // 예시: 핵심 메뉴 키
    );

    const onClickMain = () => {
        movePage('/account/manage');
        setIsMobileMenuOpen(false)
    }

    return (
        <>
            <section className={`${styles.leftCont} ${isExpanded ? styles.expanded : ""}`}>
                <div className={styles.navHeader_section}>
                    <div className={styles.navHeader} onClick={() => setIsExpanded(!isExpanded)}>
                        <div className={styles.navLogo} />
                        {isExpanded && <h1 className={styles.navTitle}>Zentry</h1>}
                    </div>

                    {/* <div className={styles.leftCont__toggleBtn} onClick={() => setIsExpanded(!isExpanded)} /> */}
                    <ul className={styles.leftCont__menu}>
                        {menusToRender.map(renderParentMenu)}
                    </ul>
                </div>

                <div className={styles.profileButtonWrapper}>
                    <InnocodeProfileButton
                        showProfile={isExpanded ? false : true}
                        type={"person"}
                        showLabel={isExpanded ? true : false}
                        label={user?.name || "사용자"}
                        showTitle={isExpanded ? true : false}
                        title={user?.email || "사용자"}
                        profile={
                            {
                                src: user?.profile_img_url,
                                alt: user?.name || "사용자",
                            }
                        }
                        className={styles.profileButton}
                    >
                        {/* <p {...{"slot": "title"}}>{user?.email || "사용자"}</p> */}
                    </InnocodeProfileButton>
                    <InnocodeButton
                        designType="assistive"
                        theme="opacity"
                        iconOnly={true}
                        enablePadding={false}
                        onClick={sessionLogout}
                        textColor="var(--static-white, #ffffff)"
                        icon={
                            <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" />
                            </svg>
                        }
                        className={styles.logoutButton}
                    ></InnocodeButton>
                    {/* <FooterInfo /> */}
                </div>

            </section>

            {/* --- 모바일 오프캔버스 메뉴 --- */}
            <div className={`${styles.mobileOffcanvasOverlay} ${isMobileMenuOpen ? styles.show : ''}`} onClick={() => setIsMobileMenuOpen(false)}>
                <section
                    className={`${styles.mobileOffcanvasMenu} ${isMobileMenuOpen ? styles.show : ''}`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className={styles.navHeader_section}>
                        <div className={styles.mobileMenuHeader}>
                            {/* 닫기 버튼 */}
                            {/* <button onClick={() => setIsMobileMenuOpen(false)} className={styles.closeButton}>
                                <span className="material-symbols-outlined">close</span>
                            </button> */}
                            <InnocodeButton
                                theme={"opacity"}
                                designType='assistive'
                                size="lg"
                                enablePadding={false}
                                iconOnly={true}
                                icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
                                </svg>
                                }
                                textColor="var(--static-white, #ffffff)"
                                onClick={() => setIsMobileMenuOpen(false)}
                            />
                            {/* <div className={styles.rightCont__header__user}>
                                <p className={styles.rightCont__header__name}>
                                    {user.name || user.email || '사용자'} 
                                </p>
                                <button className={styles.leftCont__logout} onClick={sessionLogout} />
                            </div> */}
                        </div>
                        {/* 데스크탑 메뉴 렌더링 로직 재사용 */}
                        <ul className={styles.leftCont__menu}>
                            {menusToRender.map(renderParentMenu)}
                        </ul>
                    </div>
                    <div className={styles.profileButtonWrapper}>
                        <InnocodeProfileButton
                            showProfile={false}
                            type={"person"}
                            showLabel={true}
                            label={user?.name || "사용자"}
                            showTitle={true}
                            title={user?.email || "사용자"}
                            profile={
                                {
                                    src: user?.profile_img_url,
                                    alt: user?.name || "사용자",
                                }
                            }
                            className={styles.profileButton}
                        >
                            {/* <p {...{"slot": "title"}}>{user?.email || "사용자"}</p> */}
                        </InnocodeProfileButton>
                        <InnocodeButton
                            designType="assistive"
                            theme="opacity"
                            iconOnly={true}
                            enablePadding={false}
                            onClick={sessionLogout}
                            textColor="var(--static-white, #ffffff)"
                            icon={
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2" />
                                </svg>
                            }
                            className={styles.logoutButton}
                        ></InnocodeButton>
                        {/* <FooterInfo /> */}
                    </div>
                    {/* <FooterInfo /> */}
                </section>
            </div>
        </>
    )
}

export default NavBar;
